import React from 'react';
import { noop } from 'lodash';
import cn from 'classnames';
import { bool, func, shape } from 'prop-types';
import { Input } from '@fiverr-private/fit';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { EducationTooltip } from '@fiverr-private/orca';
import { marketplaceIntegration } from '@fiverr-private/logo_maker_analytics/dist/esm/mixpanel';
import { FILTER_NAME_BY_TYPE, LOCATION } from '../../bi/mixpanel/constants';
import { BRIEF_DATA } from '../../Listings/constants';
import DropdownFilterButton from '../shared/DropdownFilterButton';
import { FILTER, TOOLTIP_STORAGE_KEY } from '../shared/constants';
import useStickyFilters from './hooks/useStickyFilters';

const { reportFilterClicked } = marketplaceIntegration;

import classes from './index.module.scss';
import MarketplaceIndustriesDropdown from './MarketplaceIndustriesDropdown';
import MarketplaceTagsDropdown from './MarketplaceTagsDropdown';

const StickyFilters = ({ briefData = {}, setBriefData = noop, isVisible }) => {
    const { handleBrandNameChange, handleSloganChange, brandName, slogan } =
        useStickyFilters({ briefData, setBriefData });

    const filterOpened = !isVisible ? false : undefined;

    return (
        <div
            className={cn(classes.stickyWrapper, 'box-shadow-z4', {
                [classes.visibleStickyWrapper]: isVisible,
            })}
        >
            <div className={classes.stickyContainer}>
                <EducationTooltip
                    title={translate(
                        'variations_display.marketplace_listing.tooltip.title'
                    )}
                    body={translate(
                        'variations_display.marketplace_listing.tooltip.body'
                    )}
                    badgeTitle={translate(
                        'variations_display.marketplace_listing.tooltip.badge'
                    )}
                    closeTitle={translate(
                        'variations_display.marketplace_listing.tooltip.cta'
                    )}
                    maxWidth={270}
                    appendToBody={false}
                    tooltipStorageKey={TOOLTIP_STORAGE_KEY}
                    bindBodyClickListener={false}
                    position={EducationTooltip.POSITIONS.TOP_LEFT}
                >
                    <Input
                        value={brandName}
                        placeholder={translate(
                            'variations_display.marketplace_listing.filters.brand.brandName.title'
                        )}
                        onChange={handleBrandNameChange}
                    />
                </EducationTooltip>
                <Input
                    value={slogan}
                    placeholder={translate(
                        'variations_display.marketplace_listing.filters.brand.slogan.title'
                    )}
                    onChange={handleSloganChange}
                />
                <DropdownFilterButton
                    opened={filterOpened}
                    filled={!!briefData.industries.length}
                    onClick={() =>
                        reportFilterClicked(
                            FILTER_NAME_BY_TYPE[FILTER.INDUSTRY],
                            LOCATION.STICKY
                        )
                    }
                    dropdown={
                        <MarketplaceIndustriesDropdown
                            setBriefData={setBriefData}
                            industries={briefData.industries}
                        />
                    }
                >
                    <I18n k="variations_display.marketplace_listing.static_filters.industry" />
                </DropdownFilterButton>
                <DropdownFilterButton
                    opened={filterOpened}
                    filled={!!briefData.keywords.length}
                    onClick={() =>
                        reportFilterClicked(
                            FILTER_NAME_BY_TYPE[FILTER.LOGO_ELEMENTS],
                            LOCATION.STICKY
                        )
                    }
                    dropdown={
                        <MarketplaceTagsDropdown
                            setBriefData={setBriefData}
                            tags={briefData.keywords}
                        />
                    }
                >
                    <I18n k="variations_display.marketplace_listing.static_filters.logo_elements" />
                </DropdownFilterButton>
            </div>
        </div>
    );
};

StickyFilters.propTypes = {
    briefData: shape(BRIEF_DATA),
    setBriefData: func,
    isVisible: bool,
};

export default StickyFilters;
